import { useAtomValue } from 'jotai';
import { ReactNode } from 'react';

import { isMediaShareModeAtom } from '../state';
import { usePictureInPicture } from '../usePictureInPicture';
import { MediaShareLayoutWrapper as MediaShareLayout } from './MediaShareLayoutWrapper';
import type { RemoteParticipantGridProps } from './RemoteParticipantGrid';
import { RemoteParticipantGridWrapper as RemoteAudioVideoGrid } from './RemoteParticipantGridWrapper';

export function SessionGrid({
  thumbnail,
  remoteParticipantComponent: RemoteParticipantComponent,
}: {
  thumbnail: ReactNode;
} & Pick<RemoteParticipantGridProps, 'remoteParticipantComponent'>) {
  const isMediaShareMode = useAtomValue(isMediaShareModeAtom);

  usePictureInPicture();

  return isMediaShareMode ? (
    <MediaShareLayout remoteParticipantComponent={RemoteParticipantComponent} thumbnail={thumbnail} />
  ) : (
    <RemoteAudioVideoGrid remoteParticipantComponent={RemoteParticipantComponent} />
  );
}
